import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { GITES } from "@/data";
import { EN, BOOK_TOGETHER } from "@/en";

const fadeUp = {
  hidden: { opacity: 0, y: 28 },
  show: (i = 0) => ({ opacity: 1, y: 0, transition: { duration: 0.6, delay: i * 0.1, ease: "easeOut" } }),
};

const EN_PATH = { "chez-anne": "/en/chez-anne", "au-19": "/en/au-19" };

export default function MaisonsEn() {
  const t = EN.cottagesPage;
  return (
    <div data-testid="page-cottages-en" className="py-20 lg:py-28">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="max-w-2xl mb-16">
          <span className="text-xs font-semibold uppercase tracking-[0.28em] text-terracotta">{t.overline}</span>
          <h1 className="font-serif text-5xl lg:text-6xl font-light mt-5 text-forest">{t.title}</h1>
          <p className="text-charcoal/70 mt-6 text-lg">{t.subtitle}</p>
        </div>

        <div className="space-y-20">
          {GITES.map((g, i) => (
            <motion.div key={g.id} data-testid={`cottages-card-${g.id}-en`} initial="hidden" whileInView="show" viewport={{ once: true, amount: 0.2 }} variants={fadeUp}
              className={`grid lg:grid-cols-2 gap-10 items-center ${i % 2 === 1 ? "lg:[&>*:first-child]:order-2" : ""}`}>
              <Link to={EN_PATH[g.id]} className="overflow-hidden rounded-2xl group">
                <img src={g.cover} alt={g.name} className="w-full h-[420px] object-cover group-hover:scale-105 transition-transform duration-700" />
              </Link>
              <div>
                <h2 className="font-serif text-4xl text-forest">{g.name}</h2>
                <a href={g.booking} target="_blank" rel="noopener noreferrer" data-testid={`cottages-reviews-${g.id}-en`} className="inline-block mt-2 text-sm text-forest underline underline-offset-4 hover:text-forest-dark">
                  {t.reviews}
                </a>
                <p className="text-charcoal/70 mt-4 leading-relaxed">{EN.cottages[g.id].tagline}</p>
                <p className="text-charcoal/60 mt-3 leading-relaxed">{EN.cottages[g.id].description}</p>
                <div data-testid={`cottages-compare-${g.id}-en`} className="mt-5 rounded-xl bg-stone/50 border border-sand px-4 py-3 text-sm text-charcoal/80 leading-relaxed">
                  <p>{t.compare(g)}</p>
                  <p className="text-charcoal/60">{EN.cottages[g.id].highlights}</p>
                </div>
                <Link to={EN_PATH[g.id]}>
                  <button data-testid={`cottages-view-${g.id}-en`} className="inline-flex items-center gap-2 mt-6 rounded-full bg-forest hover:bg-forest-dark text-cream px-7 h-11 text-sm transition-colors">
                    {t.discover(g.name)} <ArrowRight className="w-4 h-4" />
                  </button>
                </Link>
              </div>
            </motion.div>
          ))}
        </div>

        <div data-testid="cottages-booktogether-en" className="mt-16 rounded-2xl bg-stone/50 border border-sand p-8 lg:p-10 max-w-4xl">
          <p className="text-charcoal/80 leading-relaxed">{BOOK_TOGETHER}</p>
        </div>
      </div>
    </div>
  );
}
